/* eslint-disable no-unused-vars */
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/routes`;

String.prototype.allReplace = function(obj) {
  var retStr = this;
  for (var x in obj) {
    retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
  }
  return retStr;
};

let messageConfig = {
  "<p>": "&lt;span&gt;",
  "</p>": "&lt;/span&gt;",
  'class="mention"':
    'class="mention" style="font-weight: bold; display: inline;"',
  "<": "&lt;",
  ">": "&gt;",
  // '&lt;': '<',
  // '&gt;': '>',
  "a href=": 'a target="_blank" href=',
};

let messageConfigDecrypt = {
  "&lt;": "<",
  "&gt;": ">",
};

let SQL_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const state = {
  routes: [],
  unassigned_users: [],
  assigned_users: [],
  unassigned_records: [],
  assigned_records: [],
  added_receivers: [],
  selected_route: [],
  selected_route_assignments: [],
  selected_records: [],
  selected_documents: [],
  selected_record_requests: [],
  added_documents: [],
  subroutes: [],
  assigned_subroutes: [],
  selected_assigned_subroute: [],
  in_sequence_routes: [],
  non_sequence_routes: [],
  loading: false,
  totalroutes: 0,
  totalhighurgencyroutes: 0,
  totalmoderateurgencyroutes: 0,
  totallowurgencyroutes: 0,
  totalNotification: 0,
  notification_subroutes: [],
  allSubroutes: [],
  totalNotificationRegional: 0,
  routes_pending_completion: [],
  notification_regional: [],
  allChildRouteswithStatus: [],
  allDelegatedRouteswithStatus: [],
  allRouteDelegatedUsersWithStatus: [],
  route_completed_status: [],
  allIdleAssignedRoutes: [],
  totalIdle: 0,
  totalOverdue: 0,
  totalAlmostDue: 0,
  idle_subroutes: [],
  idle_routes: [],
  idle_child_routes: [],
  added_supporting_documents: [],
  listBySupportingDocuments: []
};

const getters = {
  getListSupportingDocuments: () => state.listBySupportingDocuments,
  getSupportingDocuments: () => state.added_supporting_documents,
  getIdleChildRoutes: () => state.idle_child_routes,
  getIdleSubRoutes: () => state.idle_subroutes,
  getIdleRoutes: () => state.idle_routes,
  getTotalIdle: () => state.totalIdle,
  getTotalOverdue: () => state.totalOverdue,
  getTotalAlmostDue: () => state.totalAlmostDue,
  getAllIdleAssignedRoutes: () => state.allIdleAssignedRoutes,
  getAllRouteWithCompletedStatus: () => state.route_completed_status,
  getAllRoutesWithPendingCompletion: () => state.routes_pending_completion,
  getChildRoutesWithStatus: () => state.allChildRouteswithStatus,
  getDelegatedRoutesWithStatus: () => state.allDelegatedRouteswithStatus,
  getRouteDelegatedUsersWithStatus: () => state.allRouteDelegatedUsersWithStatus,
  getTotalRoutes: () => state.totalroutes,
  getTotalHighUrgencyRoute: () => state.totalhighurgencyroutes,
  getTotalModerateUrgencyRoutes: () => state.totalmoderateurgencyroutes,
  getTotalLowUrgencyRoutes: () => state.totallowurgencyroutes,
  allRoutes: (state) => state.routes,
  getAssignedUsers: (state) => state.assigned_users,
  getUnassignedUsers: (state) => state.unassigned_users,
  getAssignedRecords: (state) => state.assigned_records,
  getUnassignedRecords: (state) => state.unassigned_records,
  addedReceivers: (state) => state.added_receivers,
  selectedRoute: (state) => state.selected_route,
  selectedRouteAssignments: (state) => state.selected_route_assignments,
  selectedRecords: (state) => state.selected_records,
  selectedDocuments: (state) => state.selected_documents,
  selectedRouteRecordRequests: (state) => state.selected_record_requests,
  addedDocuments: (state) => state.added_documents,
  getAssignedSubRoutes: (state) => state.assigned_subroutes,
  selectedAssignedSubRoute: (state) => state.selected_assigned_subroute,
  getInSequenceRoutes: (state) => state.in_sequence_routes,
  getNonSequenceRoutes: (state) => state.non_sequence_routes,
  getNotificationSubRoutes: (state) => state.notification_subroutes,
  getTotalNotification: (state) => state.totalNotification,
  getAllSubRoutes: (state) => state.allSubroutes,
  getTotalNotiifcationRegional: (state) => state.totalNotificationRegional,
  getNotificationRegional: (state) => state.notification_regional
};

const actions = {
   async fetchFilteredRoutes({commit},payload){
      commit('set_loading',true)
      commit("setRoutes", []);
      try {
          let search_value = `%${payload.search}%`
          let duration_status = payload.durationStatus
          let urgency = `%${payload.urgency}%`
          const start_date =  moment(payload.dateRange.startDate).startOf('day').format(SQL_TIME_FORMAT)
          const end_date =  moment(payload.dateRange.endDate).endOf('day').format(SQL_TIME_FORMAT)
          let query = {}  
          if(payload.urgency == "All"){
            query = {
                "$route.createdAt$": {"$between": [start_date,end_date]},
                "$and": {"$or":[
                    {"$route.subject$":{"$like":search_value}},
                    {"$route.status$":{"$like":search_value}},
                    {"$route.name$":{"$like":search_value}},
                ]}
            }
          }else{
            query = {
              "$route.createdAt$": {"$between": [start_date,end_date]},
              "$urgency$": {"$like":urgency},
              "$and": {"$or":[
                  {"$route.subject$":{"$like":search_value}},
                  {"$route.status$":{"$like":search_value}},
                  {"$route.name$":{"$like":search_value}},
              ]}
          }
          }

          const q = encodeURIComponent(JSON.stringify(query,null,4));
          const customUrl = url + '?limit=' + payload.itemsPerPage + '&query='+ q ;
          // console.log(customUrl)
          
          const authToken = localStorage.getItem('access_token');
          const response = await axios.get(customUrl, {
              headers: { 'x-drmms-token': authToken }
          });
          commit('set_loading',false)

          let routes = [];
          routes = response.data.rows.map((route) => ({
            ...route,
            isWarned: false,
            warningStatus: false,
            due: moment(route.datetime_due).format("LLL"),
            dateCreated: moment(route.createdAt).format("LLL"),
            durations: route.datetime_due,
            link: `/routes/${route.id}`,
          }));
          routes = routes.filter(route => !route.isCancelled)
          //additional filter will be placed here for overdue, idle and almost overdue routes
          if(duration_status == 'Idle'){
            routes = routes.filter(route => route.isIdle)
          }
          if(duration_status == 'Overdue'){
            routes = routes.filter(route => route.overdue_status)
          }
          if(duration_status == 'Almost Due'){
            routes = routes.filter(route => moment(route.datetime_due).diff(moment(), 'h') <= 24)
          }
          commit("setRoutes", routes);
          let set = {
            idle: routes.filter(route => route.isIdle).length,
            overdue: routes.filter(route => route.overdue_status).length,
            almostdue: routes.filter(route => moment(route.datetime_due).diff(moment(), 'h') <= 24).length
          }
          commit("setStatusCount", set)
      }
      catch(err){
          commit('set_loading',false)
      }
  },
  async fetchRoutes({ commit }, filter) {
    const { itemsPerPage } = filter;
    const customUrl = url + "?limit=" + itemsPerPage;
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.get(customUrl, {
        headers: {
          "x-drmms-token": authToken,
        },
      });
      let routes = [];
      routes = response.data.rows.map((route) => ({
        ...route,
        isWarned: false,
        warningStatus: false,
        due: route.datetime_due !== null ? moment(route.datetime_due).format("LLL") : 'No due date',
        dateCreated: moment(route.createdAt).format("LLL"),
        durations: route.datetime_due,
        link: `/routes/${route.id}`,
      }));
      let filteredOut = routes.length
      routes = routes.filter(route => !route.isCancelled)
      filteredOut = filteredOut - routes.length
      commit("setRoutes", routes);
      let set = {
        data: response.data,
        filteredOut,
        idle: routes.filter(route => route.isIdle).length,
        overdue: routes.filter(route => route.overdue_status).length,
        almostdue: routes.filter(route => moment(route.datetime_due).diff(moment(), 'h') <= 24).length
      }
      commit("setCount", set)
    } catch (err) {
      console.log(err);
    }
  },
  async fetchUnassignedUsers({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(`${url}/unassignedUsers`, body, {
        headers: {
          "x-drmms-token": authToken,
        },
      });
      if (body.users.length > 0) {
        state.assigned_users = body.users.map((user) => ({
          ...user,
          isAssigned: true,
        }));
      }

      let unassigned = response.data.map((user) => ({
        ...user,
        isAssigned: false,
      }));

      commit("setUnassignedUsers", unassigned);
    } catch (err) {
      console.log(err);
    }
  },
  async fetchUnassignedRecords({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(`${url}/unassignedRecords`, body, {
        headers: {
          "x-drmms-token": authToken,
        },
      });
      if (body.records.length > 0) {
        state.assigned_records = body.records.map((record) => ({
          ...record,
          isAssigned: true,
        }));
      }

      let unassigned = response.data.map((record) => ({
        ...record,
        isAssigned: false,
      }));

      commit("setUnassignedRecords", unassigned);
    } catch (err) {
      console.log(err);
    }
  },
  addRecord({ commit }, record) {
    commit("addRecord", record);
  },
  removeRecord({ commit }, record) {
    commit("removeRecord", record);
  },
  addNewReceiver({ commit }, body) {
    let last_sequence = 1;

    if (body.sequence_number) {
      const currentReceivers = state.added_receivers;
      currentReceivers.forEach((receiver) => {
        if (receiver.sequence_number)
          last_sequence = receiver.sequence_number + 1;
      });
    } else last_sequence = null;

    body.index = state.added_receivers.length;
    body.sequence_number = last_sequence;
    body.user = body.user.users[0]
    commit("addReceiver", body);
    return true;
  },
  removeReceiver({ commit }, receiver) {
    commit("removeReceiver", receiver);
  },
  async createRoute({ commit }, details) {
    try {
      let receivers = [];
      let documents = state.added_documents;
      state.added_receivers.forEach((element) => {
        receivers.push({
          user: element.user.id,
          action: element.action.id,
          sequence_number: element.sequence_number,
          name: element.name,
          datetime_due: element.datetime_due,
          instructions: element.instructions,
          instructions_list: element.instructions_list,
          hasActionDueDate: element.hasActionDueDate,
          subroute_statuses: element.status_template.statuses,
        });
      });
      details.receivers = receivers;
      details.documents = documents;
      let authToken = localStorage.getItem("access_token");
      let response = await axios.post(url, details, {
        headers: {
          "x-drmms-token": authToken,
        },
      });

      const newRoute = Object.assign(response.data, {
        due: response.data.datetime_due !== null ? moment(response.data.datetime_due).format("LLL") : 'No due date',
        durations: response.data.datetime_due,
        link: `/routes/${response.data.id}`,
      });

      commit("addRoute", newRoute);
      return documents;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
      console.log(err);
    }
  },
  async updateRouteDetails({ commit }, body) {
    const route_id = _.get(body, "route_id", "");
    body = _.omit(body, "route_id", "");

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "put",
        url: `${url}/${route_id}`,
        headers: {
          "x-drmms-token": authToken,
        },
        data: body,
      });

      commit("updatedRouteDetails", body);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async fetchInitiatorAttachedDocuments({commit}, document_id) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.get(`${url}/supporting_documents/${document_id}`, {
        headers: {
          "x-drmms-token": authToken,
        },
      });
      console.log(response)
      commit('setSupportingDocumentsList', response.data)
    } catch (e) {
      console.log(e)
      return e
    }
  },
  async fetchSelectedRoute({ commit }, id) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.get(`${url}/${id}`, {
        headers: {
          "x-drmms-token": authToken,
        },
      });

      let route = response.data;

      route[0].isWarned = false;
      route[0].warningStatus = false;

      let routeDue = moment(route[0].datetime_due).format("LLL");
      let dateUntil;
      let duration;

      route[0].datetime_due = routeDue;

      let dateNow = moment(new Date());

      // if(route[0].overdue_status)

      if (route[0].status == "Done") {
        duration = "Completed";
      } else if (route[0].status == "Overdue") {
        duration = "Overdue";
      } else {
        let dateUntil = moment(route[0].datetime_due);
      }

      routeDue = moment(route[0].datetime_due).format("LLL");
      route[0].datetime_due = routeDue;
      route[0].duration_hours = duration;

      let user_routes = route[0].user_route_assignments;

      for (var i = 0; i < user_routes.length; i++) {
        let formattedInstructions = user_routes[i].instructions.allReplace(
          messageConfigDecrypt
        );
        user_routes[i].instructions = formattedInstructions;

        user_routes[i].isWarned = false;
        user_routes[i].warningStatus = false;

        if (user_routes[i].status == "Done") {
          duration = "Completed";
        } else if (user_routes[i].status == "Overdue") {
          duration = "Overdue";
        } else if (user_routes[i].status == "Pending") {
          dateUntil = moment(user_routes[i].datetime_due);
          // duration = moment.duration(dateUntil.diff(dateNow));

          // if(Math.floor(duration.asHours()) < 1) {
          //     duration = 'Overdue';
          //     user_routes[i].status = 'Overdue';
          // } else {
          //     duration = Math.floor(duration.asHours()) + ' hours remaining';
          // }
        }

        routeDue = moment(user_routes[i].datetime_due).format("LLL");
        user_routes[i].datetime_due = routeDue;
        user_routes[i].duration_hours = duration;
        user_routes[i].isWarned = false;
      }

      route[0].user_route_assignments = user_routes;

      commit("setSelectedRoute", route);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async addSubRoute({ commit }, body) {
    let data = body.data;
    const parent_id = body.parent_id;
    const parent_type = body.parent_type;

    data.user_id = body.data.user.user_id ? body.data.user.user_id : body.data.user.id;
    data.action_id = body.data.action.id;
    data = _.omit(data, ["user", "action", "parent_type"]);

    const formattedInstructions = body.data.instructions.allReplace(
      messageConfig
    );
    data.instructions = formattedInstructions;
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(
        `${url}/addSubRoute/${parent_id}`,
        data,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      if (parent_type == "mainroute") {
        let route = response.data;

        let dateNow = moment(new Date());
        let dateUntil = moment(route.datetime_due);
        let duration = moment.duration(dateUntil.diff(dateNow));
        let routeDue = moment(route.datetime_due).format("LLL");

        route.datetime_due = routeDue;
        route.duration_hours = duration;
        route.instructions = body.data.instructions;

        route.isDeleted = false;
        route.isWarned = false;
        route.warningStatus = false;

        if (!route.route_delegated_users) route.route_delegated_users = [];
        if (!route.route_record_requests) route.route_record_requests = [];
        if (!route.subroute_instructions) route.subroute_instructions = [];
        if (!route.subroute_order_statuses) route.subroute_order_statuses = [];
        if (!route.subroute_status) route.subroute_status = [];

        commit("addAssignedRoute", route);
      }
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async addRouteDocument({ commit }, body) {
    const route_id = body.route_id;
    const data = _.omit(body, ["route_id", "subRouteIndex"]);

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(
        `${url}/addRouteDocument/${route_id}`,
        data,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      let res = response.data;
      res = Object.assign(res, {
        route_id,
      });

      commit("addUploadedDocument", res);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async addSubRouteDocument({ commit }, body) {
    const route_id = body.route_id;
    const accessFrom = body.accessFrom;
    const data = _.omit(body, ["route_id", "subRouteIndex", "accessFrom"]);

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(
        `${url}/addSubRouteDocument/${route_id}`,
        data,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      let res;

      if (body.isReferenced) {
        res = response.data;
        let document = _.pick(body, [
          "name",
          "type",
          "title",
          "sender",
          "address",
          "for",
          "source",
          "subject",
          "date_upload",
          "document_type",
          "filepath_url",
        ]);
        res = Object.assign(res, {
          document,
        });
      } else {
        res = response.data;
      }

      res = Object.assign(res, {
        route_id,
      });

      body = Object.assign(body, {
        created: res,
        route_id,
      });

      commit("addSubRouteDocument", body);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async addSubRouteStatus({ commit }, body) {
    const status_id = body.status.id;
    const status = body.status;
    const { save_type, remarks, route_id, previous_status_id } = body;

    const payload = {
      save_type,
      remarks,
      status_id,
      previous_status_id,
    };

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.post(
        `${url}/addSubRouteStatus/${route_id}`,
        payload,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      body.data = response.data;

      commit("addedSubRouteStatus", body);
      return response.data;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async addRouteStatus({ commit }, body) {
    const route_id = body.route_id;
    const status_id = body.status.id;

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(
        `${url}/addRouteStatus/${route_id}`,
        {
          status_id,
        },
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      commit("addedRouteStatus", body);
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async fetchAssignedSubRoutesList({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.get(`${url}/assignedRoutes`, {
        headers: {
          "x-drmms-token": authToken,
        },
      });
      console.log(response.data)
      let assignedAndDelegatedRoutes = []
      assignedAndDelegatedRoutes = response.data.assigned_routes
      response.data.delegated_routes.forEach(delegated => {
        assignedAndDelegatedRoutes.push(delegated.user_route_assignment)
      })
      let data = assignedAndDelegatedRoutes.map((route) => ({
        ...route,
        initiator_due_date: moment(route.route.datetime_due).format("lll"),
        durations: route.datetime_due,
        initiator: `${route.route.user.first_name} ${route.route.user.last_name}`,
        urgency: route.route.urgency,
        link: `/routes/assigned/${route.id}?init=${route.route.id}${
          route.parent_id != null ? "&parent=" + route.parent_id : ""
        }`,
        isWarned: false,
      }));

      commit("setAssignedSubRoutes", data);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async fetchAssignedSubRouteId({ commit }, body) {
    const parent_id = _.get(body, "parent_id", "");
    const initiator_id = _.get(body, "initiator_id", "");
    const assigned_route_id = _.get(body, "assigned_route_id", "");

    try {
      let customUrl = `${url}/assignedRoutes/${assigned_route_id}?initiator_id=${initiator_id}`;

      if (parent_id) customUrl += `&parent_id=${parent_id}`;

      const authToken = localStorage.getItem("access_token");
      let response = await axios.get(customUrl, {
        headers: {
          "x-drmms-token": authToken,
        },
      });

      let route = response.data;
      route.body = body;

      route.isWarned = false;
      route.warningStatus = false;

      let routeDue = moment(route.datetime_due).format("LLL");
      let dateUntil;
      let duration;

      route.datetime_due = routeDue;
      route.duration_hours = duration;

      route.datetime_due = routeDue;

      let dateNow = moment(new Date());

      if (route.status == "Done") {
        duration = "Completed";
      } else if (route.status == "Overdue") {
        duration = "Overdue";
      } else {
        let dateUntil = moment(route.datetime_due);
      }

      route.duration_hours = duration;

      if (route.parent_route) {
        if (route.parent_route.status == "Done") {
          duration = "Completed";
        } else if (route.parent_route.status == "Overdue") {
          duration = "Overdue";
        } else if (route.parent_route.status == "Pending") {
          dateUntil = moment(route.parent_route.datetime_due);
        }
      }

      let selected_route_assignments = [];
      let selected_assigned_subroute = {};

      for (var i = 0; i < route.user_route_assignments.length; i++) {
        let element = route.user_route_assignments[i];

        let formattedInstructions = element.instructions.allReplace(
          messageConfigDecrypt
        );
        element.instructions = formattedInstructions;

        if (element.status == "Done") {
          duration = "Completed";
        } else if (element.status == "Overdue") {
          duration = "Overdue";
        } else if (element.status == "Pending") {
          dateUntil = moment(element.datetime_due);
          // duration = moment.duration(dateUntil.diff(dateNow));

          // if(Math.floor(duration.asHours()) < 1) {
          //     duration = 'Overdue';
          //     element.status = 'Overdue';
          //     // should have api call to set status to overdue
          // } else {
          //     duration = Math.floor(duration.asHours()) + ' hours remaining';
          // }
        }

        routeDue = moment(element.datetime_due).format("LLL");
        element.datetime_due = routeDue;
        element.duration_hours = duration;
        element.isWarned = false;

        if (element.id == assigned_route_id) {
          selected_assigned_subroute = element;
        } else {
          selected_route_assignments.push(element);
        }
      }

      // selected_assigned_subroute.isWarned = false;

      route.selected_assigned_subroute = selected_assigned_subroute;
      route.user_route_assignments = selected_route_assignments;

      commit("setSelectedAssignedSubRoutes", route);

      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 403) {
          return {
            error: true,
            status: 403,
            message: "Forbidden",
          };
        }
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async updateInitiatorComplete({ commit }, id) {
    try {
      const authToken = localStorage.getItem("access_token");

      let response = await axios({
        method: "put",
        url: `${url}/done/${id}`,
        headers: {
          "x-drmms-token": authToken,
        },
        data: {},
      });

      commit("initiatorRouteComplete", id);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async deleteSupportingDocuments({commit}, ids){
    try {
      const authToken = localStorage.getItem('access_token');
      const response = await axios({
          method: "delete",
          url: `${url}/supporting_documents`,
          headers: { "x-drmms-token": authToken },
          data: { ids },
      });
      commit('removeSupportingDocument', ids);
      console.log(response)
      return response;
    } catch (err) {
      return { error: true, status: err.response.status, message: err.response.data }
    }
  },
  async clearSupportingDocuments({commit}, empty){
    try{
      commit("clearSupportingDocument", empty)
      return true
    } catch (err) {
      return err
    }
  },
  async attachSupportingDocuments({ commit }, body){
    try {
      
        commit("attachSupportingDocument", body)
    } catch (err){
      return err
    }
  },
  async attachDocuments({ commit }, documents) {
    let mapped = [];
    let ids = [];
    documents.forEach((document, index) => {
      mapped.push(
        Object.assign(document, {
          index,
          isMainDocument: index == 0 ? true : false,
        })
      );
      ids.push(document.id);
    });

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.get(
        `${url}/incoming_receivers/fetch/${ids[0]}`,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      let commitObject = {
        documents: mapped,
        receivers: response.data,
      };

      commit("attachRouteDocuments", commitObject);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async attachRouteDocument({ commit }, body) {
    body.isMainDocument = state.added_documents.length > 0 ? false : true;
    body.index = state.added_documents.length + 1;
    commit("pushAddedDocuments", body);
    return true;
  },
  async setRouteOverdue({ commit }, body) {
    const { route_id, type } = body;

    let customUrl =
      type != "mainroute"
        ? `${url}/assignedRoute/update/overdue/${route_id}`
        : `${url}/mainRoute/update/overdue/${route_id}`;

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios({
        method: "put",
        url: customUrl,
        headers: {
          "x-drmms-token": authToken,
        },
      });

      commit("setOverdueRoute", body);
    } catch (err) {
      console.log(err);
    }
  },
  async attachRecords({ commit }, body) {
    let { type, route_id, records, remarks } = body;

    let customUrl =
      type == "mainroute"
        ? `${url}/route/records/attach/${route_id}`
        : `${url}/subroute/records/attach/${route_id}`;

    let record_ids = [];

    try {
      let currentRecords;
      if (type == "mainroute") {
        currentRecords = state.selected_records;
      } else {
        let subroutes = state.selected_route_assignments;
        let index = subroutes.findIndex((route) => route.id == route_id);
        currentRecords = state.selected_route_assignments[index].records;

        body.route_index = index;
      }

      let currentIds = [];
      let newRecords = [];

      currentRecords.forEach((element) => currentIds.push(element.id));

      records.forEach((element) => {
        if (!currentIds.includes(element.id)) {
          newRecords.push(element);
          record_ids.push(element.id);
        }
      });

      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(
        customUrl,
        {
          record_ids,
          remarks,
        },
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      body.records = newRecords;

      commit("setAttachedRecords", body);
      return true;
    } catch (err) {
      console.log(err);
    }
  },
  async warnRouteStatus({ commit }, body) {
    commit("updateRouteStatusWarning", body);
  },
  async fetchRouteLog({ commit }, body) {
    let { route_id, type } = body;

    let customUrl = `${url}/activity/logs/${type}/${route_id}`;

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.get(customUrl, {
        headers: {
          "x-drmms-token": authToken,
        },
      });

      let data = response.data;
      let logs = [];
      let notifLogCount = 0;

      response.data.forEach((l) => {
        logs.push({
          from: `${l.user.first_name} ${l.user.last_name}`,
          message: l.description,
          time: moment(l.createdAt).format("lll"),
          color: l.route_log_color,
          icon: l.route_log_icon,
          id: l.id,
          notifStatus: l.notifStatus,
        });
        if (l.notifStatus) notifLogCount++;
      });

      const commitBody = {
        ...body,
        notifLogCount,
        logs,
      };
      commit("addRouteLog", commitBody);

      return logs;
    } catch (err) {
      console.log(err);
    }
  },
  async updateInitiatorUndone({ commit }, id) {
    try {
      const authToken = localStorage.getItem("access_token");

      let response = await axios({
        method: "put",
        url: `${url}/undone/${id}`,
        headers: {
          "x-drmms-token": authToken,
        },
        data: {},
      });

      commit("initiatorRouteUndone", id);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  toggleMainRouteDocument({ commit }, body) {
    commit("setRouteMainDocument", body);
    return true
  },
  clearReceivers({ commit }) {
    commit("clearAddedReceivers");
  },
  updateAddedReceiver({ commit }, body) {
    const instructions = body.instructions.allReplace(messageConfig);
    body.instructions = instructions;
    commit("updateReceiverDetails", body);
    return true;
  },
  updateMultipleReceiver({commit}, body){
    body.forEach(item => {
      const instructions = item.instructions.allReplace(messageConfig);
      item.instructions = instructions;
      commit("updateReceiverDetails", item);
    })
    return true;
  },
  addReceiverInstructions({ commit }, body) {
    let instructions = body.instructions;
    instructions = instructions.allReplace(messageConfig);
    body.instructions = instructions;
    commit("setReceiverInstructions", body);
  },
  async addSubrouteOutputDocument({ commit }, body) {
    const { route_id } = body;
    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.post(
        `${url}/subroutes/documents/add/output/${route_id}`,
        body,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      const commitObject = Object.assign(body, {
        created: response.data,
      });

      commit("addOutputDocument", commitObject);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async addInitiatorSupportingDocument({ commit }, body) {
    const { route_id } = body;
    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.post(
        `${url}/documents/add/supporting/${route_id}`,
        body,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      const commitObject = Object.assign(body, {
        created: response.data,
      });

      commit("addSupportingDocument", commitObject);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async addSubrouteSupportingDocument({ commit }, body) {
    const { route_id } = body;
    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.post(
        `${url}/subroutes/documents/add/supporting/${route_id}`,
        body,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      const commitObject = Object.assign(body, {
        created: response.data,
      });

      commit("addSubrouteSupportingDocument", commitObject);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async attachToParentOutputDocument({ commit }, body) {
    const { parent_id } = body;
    const data = _.omit(body, ["document", "parent_id"]);
    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios.post(
        `${url}/parent/documents/add/output/${parent_id}`,
        data,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      commit("attachParentOutputDocument", body);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async routeUpdateDocumentVersion({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(
        `${apiServerUrl}/documents/uploadNewVersion/${body.document_id}`,
        body,
        {
          headers: {
            "x-drmms-token": authToken,
          },
        }
      );

      body.newInstance = response.data;

      commit("updateNewRouteDocumentSource", body);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async removeRouteDocument({ commit }, body) {
    const customUrl =
      body.route_type != "mainroute"
        ? `${url}/assignedRoute/document/${body.route_id}/${body.initiator_id}`
        : `${url}/document/${body.initiator_id}`;

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "delete",
        url: customUrl,
        data: body,
        headers: {
          "x-drmms-token": authToken,
        },
      });

      commit("removeDocumentFromRoute", body);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async addRouteCommentCount({ commit }, route) {
    commit("setNewRouteCommentCount", route);
  },
  async removeRouteRecord({ commit }, body) {
    const customUrl =
      body.route_type != "mainroute"
        ? `${url}/assignedRoute/record/${body.initiator_id}/${body.route_id}`
        : `${url}/record/${body.initiator_id}`;

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "delete",
        url: customUrl,
        data: body,
        headers: {
          "x-drmms-token": authToken,
        },
      });

      commit("removeRecordFromRoute", body);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async deleteSecondaryRoute({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "delete",
        url: `${url}/subroute/${body.route_id}`,
        data: body,
        headers: {
          "x-drmms-token": authToken,
        },
      });

      commit("removeSecondaryRoute", body);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  addRequestToRoute({ commit }, body) {
    commit("setAddedRequestToRoute", body);
  },
  async setSecondaryRouteCompleted({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "put",
        url: `${url}/assignedRoute/update/done/${body.route_id}`,
        headers: {
          "x-drmms-token": authToken,
        },
      });

      commit("updateRouteCompletion", body);
      return response.data;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 403)
          return {
            error: true,
            status: 403,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async delegateSubroute({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(`${url}/subroute/delegate`, body.data, {
        headers: {
          "x-drmms-token": authToken,
        },
      });

      commit("setDelegatedSubroute", body);
      return response.data;
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 403)
          return {
            error: true,
            status: 403,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async confirmRouteStatus({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(`${url}/subroute/confirmStatus`, body, {
        headers: {
          "x-drmms-token": authToken,
        },
      });

      console.log('confirm status', response);
      commit("setConfirmedRouteStatus", body);
    } catch (err) {
      if (err.response) {
        if (err.response.status == 400)
          return {
            error: true,
            status: 400,
            message: err.response.data,
          };
        else if (err.response.status == 403)
          return {
            error: true,
            status: 403,
            message: err.response.data,
          };
        else if (err.response.status == 500)
          return {
            error: true,
            status: 500,
            message: "Internal Server Error",
          };
      }
    }
  },
  async subRouteOverviewLogs({commit}, id){
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        url: `${url}/subroute/logs/overall/${id}`,
        method: "get",
        headers: {
          "x-drmms-token": authToken,
        },
      });
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
  async overviewLogs({commit}, id){
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        url: `${url}/logs/overall/${id}`,
        method: "get",
        headers: {
          "x-drmms-token": authToken,
        },
      });
      return response.data;

    } catch (err) {
      console.log(err);
    }
  },
  async viewLogStatus({ commit }, body) {
    const { logs } = body;

    const log_ids = [];
    logs.forEach((log) => {
      log_ids.push(log.id);
    });

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        url: `${url}/logs/view`,
        method: "put",
        headers: {
          "x-drmms-token": authToken,
        },
        data: {
          log_ids,
        },
      });

      commit("setLogStatusViewed", body);
      return true;
    } catch (err) {
      console.log(err);
    }
  },
  async updateRouteAutoComplete({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");

      await axios({
        method: 'put',
        url: `${url}/trigger/autocomplete/${body.route_id}`,
        data: { status: body.status },
        headers: { "x-drmms-token": authToken }
      });

      commit('updateRouteAutoCompleteStatus', body);

    } catch(err) {
      console.log(err);
    }
  },
  async rejectPendingDocuments({commit}, body){
    try{
      const authToken = localStorage.getItem("access_token");

      let response = await axios({
        method: 'post',
        url: `${url}/reject`,
        data: body,
        headers: { 'x-drmms-token': authToken}
      })
      return response
    } catch(err) {
      console.log(err);
    }
  },
  async switchMainDocument({commit}, body) {
    try{
      const authToken = localStorage.getItem("access_token");
      let response = await axios({
        method: 'post',
        url: `${url}/switchMainDocument`,
        data: body,
        headers: { 'x-drmms-token': authToken}
      })
      return response
    } catch(err) {
      console.log(err);
    }
  },
  async fetchAssignedSubRoutesById({commit}, id){
    try{
      const authToken = localStorage.getItem("access_token");

      let response = await axios.get(`${url}/assignedSubRoutes/${id}`, { headers: { 'x-drmms-token': authToken }})
      commit('setNotificationData', response.data)
      return response.data
    } catch (error){
      console.log(error)
      return error
    }
  },
  async fetchRegionalDirectorNotifications({commit}, id){
    try{
      const authToken = localStorage.getItem("access_token");

      let response = await axios.get(`${url}/notification/regional/${id}`, { headers: { 'x-drmms-token': authToken }})
      console.log(response.data)
      commit('setNotificationDataRegional', response.data)
    } catch (error){
      console.log(error)
      return error
    }
  }
};

// !MUTATIONS START HERE

const mutations = {
  setNotificationDataRegional: (state, data) => {
    state.routes_pending_completion = data.routes_pending_completion
    state.totalNotificationRegional = data.assigned_route_status.count
    state.notification_regional = data.assigned_route_status.rows
    state.idle_subroutes = data.idle_assigned_routes
    state.idle_routes = data.idle_routes
  },
  setNotificationData: (state, data) => {
    state.allIdleAssignedRoutes = data.idle_assigned_routes
    state.totalNotification = data.assignments.count
    state.notification_subroutes = data.assignments.rows
    state.allSubroutes = data.allsubroutes
    state.allChildRouteswithStatus = data.allchildroutes
    state.allDelegatedRouteswithStatus = data.delegated_users
    state.allRouteDelegatedUsersWithStatus = data.assignments_delegated_users
    state.route_completed_status = data.route_completed_status
    state.idle_child_routes = data.idle_child_routes
  },
  setRoutes: (state, routes) => (state.routes = routes),
  setStatusCount: (state, {idle, overdue, almostdue}) => {
    state.totalIdle = idle
    state.totalOverdue = overdue
    state.totalAlmostDue = almostdue
  },
  setCount: (state, {data, filteredOut, idle, overdue, almostdue}) => {
    state.totalroutes = data.count - filteredOut
    state.totalmoderateurgencyroutes = data.rows.filter(function(item){
      return item.urgency == "Moderate" && item.isCancelled == false;
    }).length;
    state.totalhighurgencyroutes = data.rows.filter(function(item){
      return item.urgency == "High" && item.isCancelled == false;
    }).length;
    state.totallowurgencyroutes = data.rows.filter(function(item){
      return item.urgency == "Low" && item.isCancelled == false;
    }).length;
    state.totalIdle = idle
    state.totalOverdue = overdue
    state.totalAlmostDue = almostdue
  },
  set_loading: (state,status) => { state.loading = status},
  addRoute: (state, route) => {
    route.dateCreated = moment(route.createdAt).format("LLL");
    state.routes.push(route);
  },
  setUnassignedUsers: (state, users) => (state.unassigned_users = users),
  addUser: (state, user) => {
    state.assigned_users.push(user);
    state.unassigned_users = state.unassigned_users.filter(
      (checkUser) => checkUser.id !== user.id
    );
  },
  updateUsers: (state, id) => {
    const index = state.users.findIndex((user) => user.id === id);
    if (index !== -1) {
      let updated = state.users[index];
      updated.users = state.assigned_users;
      state.users.splice(index, 1, updated);
      state.unassigned_users = [];
      state.assigned_users = [];
    }
  },
  setUnassignedRecords: (state, records) =>
    (state.unassigned_records = records),
  addRecord: (state, record) => {
    state.assigned_records.push(record);
    state.unassigned_records = state.unassigned_records.filter(
      (checkRecord) => checkRecord.id !== record.id
    );
  },
  removeRecord: (state, record) => {
    state.unassigned_records.push(record);
    state.assigned_records = state.assigned_records.filter(
      (checkRecord) => checkRecord.id !== record.id
    );
  },
  addReceiver: (state, receiver) => state.added_receivers.push(receiver),
  removeReceiver: (state, receiver) => {
    state.added_receivers = state.added_receivers.filter(
      (checkReceiver) => checkReceiver.index !== receiver.index
    );
    if (receiver.sequence_number) {
      const index = receiver.index;
      let sequence_number = receiver.sequence_number;
      let currentReceivers = state.added_receivers;
      for (var i = index; i < currentReceivers.length; i++) {
        currentReceivers[i].index = i;
        if (currentReceivers[i].sequence_number) {
          currentReceivers[i].sequence_number = sequence_number;
          sequence_number++;
        }
        state.added_receivers.splice(i, 1, currentReceivers[i]);
      }
    }
  },
  setSupportingDocumentsList: (state, data) => {
    state.listBySupportingDocuments = data[0]
  },
  setSelectedRoute: (state, route) => {
    state.selected_route = route;
    state.selected_records = route[0].records;
    state.selected_route_assignments = route[0].user_route_assignments;
    state.selected_documents = route[0].document_instances;
    state.selected_record_requests = route[0].route_record_requests;

    let assigned_routes = route[0].user_route_assignments;

    let in_sequence = [];
    let non_sequence = [];

    assigned_routes.forEach((element) => {
      if (!element.sequence_number) non_sequence.push(element);
      else in_sequence.push(element);
    });

    state.in_sequence_routes = in_sequence;
    state.non_sequence_routes = non_sequence;
  },
  addUploadedDocument: (state, document) => {
    state.selected_documents.push(document);
  },
  addSubRouteDocument: (state, newDocument) => {
    const document = newDocument.created;
    const route_id = newDocument.route_id;
    const subRouteIndex = newDocument.subRouteIndex;
    const accessFrom = newDocument.accessFrom;

    let documentsArray = [];
    let index, selected_route;

    document.document_type = newDocument.document_type;

    if (accessFrom == "assigned_route") {
      if (index !== -1) {
        state.selected_assigned_subroute.documents.push(document);
      }
    } else {
      if (subRouteIndex) {
        index = state.subroutes[subRouteIndex].data.findIndex(
          (route) => route.id === route_id
        );
        selected_route = state.subroutes[subRouteIndex].data[index];
      } else {
        index = state.selected_route_assignments.findIndex(
          (route) => route.id === route_id
        );
        selected_route = state.selected_route_assignments[index];
      }

      documentsArray = selected_route.document_instances;
      documentsArray.push(document);
      selected_route.documents = documentsArray;

      if (index !== -1) {
        if (subRouteIndex) {
          state.subroutes[subRouteIndex].data.splice(index, 1, selected_route);
        } else {
          state.selected_route_assignments.splice(index, 1, selected_route);
        }
      }
    }
  },
  addedRouteStatus: (state, body) => {
    state.selected_route[0].statuses.push(body.status);
  },
  addedSubRouteStatus: (state, subroutes) => {
    let index = null;

    // const subroute_status = {
    //     confirm_status: 'pending',
    //     confirmation_remarks: null,
    //     remarks: subroutes.data.remaks,
    //     status: {
    //         id: subroutes.data.status_id,
    //         name: subroutes.data.name
    //     }
    // }

    if (subroutes.routeType != "mainroute") {
      index = state.selected_route_assignments.findIndex(
        (route) => route.id === subroutes.route_id
      );

      if (index !== -1) {
        if (subroutes.save_type == "update") {
          let findStatusIndex = state.selected_route_assignments[
            index
          ].subroute_status.findIndex((e) => e.id == subroutes.data.id);

          if (findStatusIndex !== -1) {
            // state.selected_route_assignments[index].statuses[findStatusIndex] = subroute_status;
            state.selected_route_assignments[index].subroute_status[
              findStatusIndex
            ] = subroutes.data;
          } else {
            findStatusIndex =
              state.selected_route_assignments[index].statuses.length - 1;
            // state.selected_route_assignments[index].statuses[findStatusIndex] = subroute_status;
            state.selected_route_assignments[index].subroute_status[
              findStatusIndex
            ] = subroutes.data;
          }
          // state.selected_route_assignments[index].statuses(subroutes.data);
          // state.selected_route_assignments[index].subroute_status.push(subroute_status);
        } else {
          // state.selected_route_assignments[index].statuses.push(subroutes.data);
          state.selected_route_assignments[index].subroute_status.push(
            subroutes.data
          );
        }
        // state.selected_route_assignments[index].statuses.push(subroutes.data);
        // state.selected_route_assignments[index].subroute_status.push(subroute_status);
      }
    }
  },
  setAssignedSubRoutes: (state, routes) => (state.assigned_subroutes = routes),
  setSelectedAssignedSubRoutes: (state, routes) => {
    state.selected_route = routes;
    state.selected_records = routes.records;
    state.selected_documents = routes.document_instances;
    state.selected_assigned_subroute = routes.selected_assigned_subroute;
    state.selected_route_assignments = routes.user_route_assignments;
    state.selected_record_requests = routes.route_record_requests;
  },
  initiatorRouteComplete: (state, route_id) => {
    state.selected_route[0].status = "Done";
  },
  updatedRouteDetails: (state, route) => {
    state.selected_route[0].name = route.name;
    state.selected_route[0].label = route.label;
    state.selected_route[0].security_level = route.security_level;
    state.selected_route[0].urgency = route.urgency;
    state.selected_route[0].subject = route.subject;
    state.selected_route[0].datetime_due = route.datetime_due;
  },
  addAssignedRoute: (state, route) => {
    state.selected_route_assignments.push(route);
    state.non_sequence_routes.push(route);
  },
  removeSupportingDocument:(state, ids) => {
    state.added_supporting_documents = state.added_supporting_documents.filter(item => !ids.includes(item.document.id))
    state.listBySupportingDocuments = state.listBySupportingDocuments.filter(item => !ids.includes(item.id))
  },
  clearSupportingDocument: (state, empty) => {
    state.added_supporting_documents = empty
  },
  attachSupportingDocument: (state, body) => {
    let documents = body.documents
    let isUpdate = body.isUpdate
    console.log(isUpdate)
    console.log(documents)
    if(isUpdate)
      state.added_supporting_documents = []
    documents.forEach(document => {
      state.added_supporting_documents.push(document)
    })
  },
  attachRouteDocuments: (state, object) => {
    const { documents, receivers } = object;
    state.added_documents = documents;
    state.added_receivers = []
    receivers.forEach((element, index) => {
      let user = element.user;
      user.name = `${element.user.first_name} ${element.user.middle_name} ${element.user.last_name}`;
      // let receiver = Object.assign(element, { user });

      state.added_receivers.push({
        index,
        user,
        datetime_due: new Date(
          moment(new Date())
            .add(3, "days")
            .format("MMMM DD, YYYY")
        )
          .toISOString()
          .substr(0, 10),
      });
    });
  },
  pushAddedDocuments: (state, document) => state.added_documents.push(document),
  setAttachedRecords: (state, body) => {
    let { type, route_id, records, route_index, remarks } = body;

    try {
      if (type == "mainroute") {
        let currentRecords = state.selected_records;

        records.forEach((record) => {
          record.record_route = [
            {
              remarks,
            },
          ];
        });

        currentRecords = currentRecords.concat(records);

        state.selected_route[0].records = currentRecords;
        state.selected_records = currentRecords;
      } else {
        let currentRecords =
          state.selected_route_assignments[route_index].records;

        records.forEach((record) => {
          record.record_subroute = [
            {
              remarks,
            },
          ];
        });

        currentRecords = currentRecords.concat(records);
        let assigned_route = state.selected_route_assignments[route_index];
        assigned_route.records = currentRecords;
        if (route_index !== -1) {
          state.selected_route_assignments.splice(
            route_index,
            1,
            assigned_route
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  },
  updateRouteStatusWarning: (state, body) => {
    let { route_id, type, listAccess } = body;

    if (type != "mainroute") {
      if (listAccess == "list") {
        let routes = state.assigned_subroutes;
        let index = routes.findIndex((r) => r.id === route_id);

        if (index !== -1) {
          let route = routes[index];
          route.warningStatus = true;
          route.isWarned = true;

          state.assigned_subroutes.splice(index, 1, route);
        }
      } else {
        if (listAccess == "mainroute") {
          let routes = state.selected_route_assignments;
          let index = routes.findIndex((r) => r.id === route_id);

          if (index !== -1) {
            let route = routes[index];
            route.warningStatus = true;
            route.isWarned = true;

            state.selected_route_assignments.splice(index, 1, route);
          }
        } else {
          let route = state.selected_assigned_subroute;
          route.warningStatus = true;
          route.isWarned = true;

          state.selected_assigned_subroute = route;
        }
      }
    } else {
      if (listAccess == "list") {
        let routes = state.routes;
        let index = routes.findIndex((r) => r.id === route_id);

        if (index !== -1) {
          let route = routes[index];
          route.warningStatus = true;
          route.isWarned = true;

          state.routes.splice(index, 1, route);
        }
      } else {
        state.selected_route[0].warningStatus = true;
        state.selected_route[0].isWarned = true;
      }
    }
  },
  initiatorRouteUndone: (state, id) => {
    state.selected_route[0].status = "Pending";
    state.selected_route[0].isWarned = false;
    state.selected_route[0].warningStatus = false;
  },
  setOverdueRoute: (state, body) => {
    let { route_id, type, listAccess } = body;

    if (type != "mainroute") {
      if (listAccess == "list") {
        let routes = state.assigned_subroutes;
        let index = routes.findIndex((r) => r.id === route_id);

        if (index !== -1) {
          let route = routes[index];
          route.overdue_status = true;
          route.isWarned = true;

          state.assigned_subroutes.splice(index, 1, route);
        }
      } else {
        let routes = state.selected_route_assignments;
        let index = routes.findIndex((r) => r.id === route_id);

        if (index !== -1) {
          let route = routes[index];
          route.overdue_status = true;
          route.isWarned = true;

          state.selected_route_assignments.splice(index, 1, route);
        }
      }
    } else {
      if (listAccess == "list") {
        let routes = state.routes;
        let index = routes.findIndex((r) => r.id === route_id);

        if (index !== -1) {
          let route = routes[index];
          route.overdue_status = true;
          route.isWarned = true;

          state.routes.splice(index, 1, route);
        }
      } else {
        state.selected_route[0].overdue_status = true;
        state.selected_route[0].isWarned = true;
      }
    }
  },
  setRouteMainDocument: (state, body) => {
    state.added_documents[body.index].isMainDocument = body.val
    let temp = state.added_documents
    state.added_documents = []
    state.added_documents = temp
    // if (state.added_documents[index].isMainDocument) {
    //   if (index != 0) {
    //     state.added_documents[index].isMainDocument = true;
    //   } else {
    //     state.added_documents[0].isMainDocument = true;
    //   }
    //   state.added_documents[index].isMainDocument = true;
    // } else {
    //   let findCurrentMainIdx = state.added_documents.findIndex(
    //     (document) => document.isMainDocument === true
    //   );

    //   if (findCurrentMainIdx !== -1) {
    //     state.added_documents[findCurrentMainIdx].isMainDocument = false;
    //     state.added_documents[index].isMainDocument = true;
    //   }
    // }
  },
  clearAddedReceivers: (state) => (state.added_receivers = []),
  updateReceiverDetails: (state, receiver) => {
    let selected = state.added_receivers[receiver.selected.index];
    selected = Object.assign(selected, {
      datetime_due: receiver.datetime_due,
      user: receiver.user.users[0],
      action: receiver.action,
      instructions: receiver.instructions,
      instructions_list: receiver.instructions_list,
      hasActionDueDate: receiver.hasActionDueDate,
      status_template: receiver.status_template,
    });

    state.added_receivers[receiver.selected.index] = selected;
  },
  setReceiverInstructions: (state, receivers) => {
    let { receiver, instructions } = receivers;
    let selected = state.added_receivers[receiver.index];
    selected.instructions = instructions;
  },
  addOutputDocument: (state, documents) => {
    const { route_id, created } = documents;

    let index = state.selected_route_assignments.findIndex(
      (route) => route.id === route_id
    );

    if (index !== -1) {
      state.selected_route_assignments[index].document_instances.push(created);
    }
  },
  addSubrouteSupportingDocument: (state, document) => {
    const { route_id, created } = document;
    let index = state.selected_route_assignments.findIndex(
      (route) => route.id === route_id
    );

    if (index !== -1) {
      state.selected_route_assignments[index].document_instances.push(created);
    }
  },
  attachParentOutputDocument: (state, body) => {
    const { parent_id, document } = body;

    let index = state.selected_route_assignments.findIndex(
      (route) => route.id == parent_id
    );

    if (index !== -1) {
      document.document_route_assignments.user_route_assignment_id = parseInt(
        parent_id
      );
      state.selected_route_assignments[index].document_instances.push(document);
    }
  },
  addSupportingDocument: (state, document) => {
    const { created } = document;
    state.selected_documents.push(created);
  },
  updateNewRouteDocumentSource: (state, data) => {
    const { route_id, document_instance_id, filepath_url, type } = data;

    if (type != "mainroute") {
      let routeIndex = state.selected_route_assignments.findIndex(
        (route) => route.id == route_id
      );

      if (routeIndex !== -1) {
        let selectedRoute = state.selected_route_assignments[routeIndex];
        let documentIndex = selectedRoute.document_instances.findIndex(
          (d) => d.id == document_instance_id
        );

        if (documentIndex !== -1) {
          state.selected_route_assignments[routeIndex].document_instances[
            documentIndex
          ].filepath_url = filepath_url;
        }
      }
    } else {
      let index = state.selected_documents.findIndex(
        (e) => e.id === document_instance_id
      );

      if (index !== -1) {
        state.selected_documents[index].filepath_url = filepath_url;
      }
    }
  },
  removeDocumentFromRoute: (state, body) => {
    const {
      route_id,
      initiator_id,
      route_type,
      document_id,
      document_type,
    } = body;

    if (route_type == "mainroute") {
      if (document_type == "supporting") {
        let newDocuments = state.selected_documents.filter(
          (document) => document.id != document_id
        );
        state.selected_documents = newDocuments;
      }
    } else {
      let index = state.selected_route_assignments.findIndex(
        (route) => route.id == route_id
      );

      if (index !== -1) {
        let newDocuments = state.selected_route_assignments[
          index
        ].document_instances.filter((document) => document.id != document_id);
        state.selected_route_assignments[
          index
        ].document_instances = newDocuments;
      }
    }
  },
  setNewRouteCommentCount: (state, body) => {
    const { type, newComment, selected_route_id, accessFrom } = body;

    if (type != "mainroute") {
      let index = state.selected_route_assignments.findIndex(
        (r) => r.id == selected_route_id
      );

      if (index !== -1) {
        state.selected_route_assignments[index].assigned_route_comments.push(
          newComment
        );
      }
    } else {
      if (state.selected_route[0]) {
        state.selected_route[0].route_comments.push(newComment);
      } else {
        state.selected_route.route_comments.push(newComment);
      }
    }
  },
  removeRecordFromRoute: (state, body) => {
    const { route_id, initiator_id, route_type, record_id } = body;

    if (route_type == "mainroute") {
      let newRecords = state.selected_records.filter(
        (record) => record.id != record_id
      );
      state.selected_records = newRecords;
    } else {
      let index = state.selected_route_assignments.findIndex(
        (route) => route.id == route_id
      );

      if (index !== -1) {
        let newRecords = state.selected_route_assignments[index].records.filter(
          (record) => record.id != record_id
        );
        state.selected_route_assignments[index].records = newRecords;
      }
    }
  },
  removeSecondaryRoute: (state, body) => {
    const { route_id } = body;
    state.selected_route_assignments.filter((route) => route.id != route_id);

    let index = state.selected_route_assignments.findIndex(
      (route) => route.id == route_id
    );

    state.selected_route_assignments[index].isDeleted = true;
  },
  setAddedRequestToRoute: (state, body) => {
    const { type } = body;

    if (type == "mainroute") {
      state.selected_record_requests.push(body);
    } else {
      const index = state.selected_route_assignments.findIndex(
        (r) => r.id === body.user_route_assignment_id
      );

      if (index !== -1) {
        state.selected_route_assignments[index].route_record_requests.push(
          body
        );
      }
    }
  },
  updateRouteCompletion: (state, body) => {
    const { route_id, access_from } = body;

    if (access_from != "assigned_route") {
      let index = state.selected_route_assignments.findIndex(
        (r) => r.id === route_id
      );

      if (index !== -1) {
        state.selected_route_assignments[index].status = "Done";
      }
    } else {
      if (state.selected_assigned_subroute.id == route_id) {
        state.selected_assigned_subroute.status = "Done";
      }
    }
  },
  setDelegatedSubroute: (state, body) => {
    const { data, access_from, user } = body;
    const { route_id, user_id, dateEffectiveUntil } = data;

    if (access_from == "assigned_route") {
      state.selected_assigned_subroute.route_delegated_users.push(user);
    } else {
      const index = state.selected_route_assignments.findIndex(
        (r) => r.id === route_id
      );

      if (index !== -1) {
        state.selected_route_assignments[index].route_delegated_users.push({
          user,
        });
      }
    }
  },
  setConfirmedRouteStatus: (state, body) => {
    const { route_id, action, id, remarks } = body;

    let isConfirmed = action != "reject" ? true : false;

    const routeIndex = state.selected_route_assignments.findIndex(
      (r) => r.id === route_id
    );

    if (routeIndex !== -1) {
      const selectedSubroute = state.selected_route_assignments[routeIndex];
      const actionIndex = selectedSubroute.subroute_status.findIndex(
        (s) => s.id === id
      );

      if (actionIndex !== -1) {
        let statusObj =
          state.selected_route_assignments[routeIndex].subroute_status[
            actionIndex
          ];

        if (action != "reject") {
          state.selected_route_assignments[routeIndex].subroute_status[
            actionIndex
          ] = Object.assign(statusObj, {
            confirm_status: "confirmed",
            confirmation_remarks: remarks,
          });
        } else {
          state.selected_route_assignments[routeIndex].subroute_status.pop();
        }
      }
    }
  },
  addRouteLog: (state, body) => {
    const { route_id, type, notifLogCount, logs, accessFrom } = body;

    if (type != "mainroute") {
      if (
        accessFrom == "assigned_route" &&
        state.selected_assigned_subroute.id == route_id
      ) {
        state.selected_assigned_subroute.logs = logs;
        state.selected_assigned_subroute.notifLogCount = notifLogCount;
      } else {
        const index = state.selected_route_assignments.findIndex(
          (r) => r.id == route_id
        );

        if (index !== -1) {
          state.selected_route_assignments[index].logs = logs;
          state.selected_route_assignments[index].notifLogCount = notifLogCount;
        }
      }
    } else {
      state.selected_route.logs = logs;
      state.selected_route.notifLogCount = notifLogCount;
    }
  },
  setLogStatusViewed: (state, body) => {
    const { route_id, type, logs } = body;

    const viewedLogs = logs.map((log) => ({
      ...log,
      notifStatus: false,
    }));

    // continue here
    if (type == "mainroute") {
      console.log("test");
    } else {
      const index = state.selected_route_assignments.findIndex(
        (r) => r.id === route_id
      );

      if (index !== -1) {
        state.selected_route_assignments[index].logs = viewedLogs;
        state.selected_route_assignments[index].notifLogCount = 0;
      }
    }
  },
  updateRouteAutoCompleteStatus: (state, body) => {
    const { status, route_id } = body;

    const index = state.selected_route_assignments.findIndex((route) => route.id === route_id);

    if(index !== -1) {
      state.selected_route_assignments[index].autoCompleteTrigger = status;
      state.selected_route[0].user_route_assignments[index].autoCompleteTrigger = status;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
